export function isCalendarIntegration(integrationType: string) {
  return integrationType !== 'PULSAR'
}
